import React from 'react';
import { formatDate } from '@koob/dates';

export interface FolderDateRangeProps {
  startAt?: string | null;
  endAt?: string | null;
}

/**
 * KD-3842: "dd/mm/yyyy → dd/mm/yyyy", a single date when the service starts
 * and ends the same day, "--" without any date. A narrow column puts the end
 * date on a second line, never a date across two (KD-3910).
 */
export default function FolderDateRange({
  startAt,
  endAt,
}: FolderDateRangeProps) {
  if (!startAt && !endAt) {
    return <span className="text-gray-400">--</span>;
  }

  const start = formatDate(startAt ?? endAt, 'DD/MM/YYYY');
  const end = formatDate(endAt ?? startAt, 'DD/MM/YYYY');

  return (
    <span className="inline-flex items-baseline gap-1.5 text-sm">
      <i className="fa-regular fa-calendar text-gray-400" aria-hidden="true" />
      <span className="flex flex-wrap gap-x-1">
        <span className="whitespace-nowrap">{start}</span>
        {start !== end && <span className="whitespace-nowrap">→ {end}</span>}
      </span>
    </span>
  );
}
